import { computed, ref, watch } from "vue";

import { useAppStore } from "@/stores";

const STORAGE_OPEN = "quickstart-sidebar-open";
const STORAGE_DISMISSED = "quickstart-button-dismissed";

const ready = ref(false);
const sidebarOpen = ref(localStorage.getItem(STORAGE_OPEN) === "true");
const buttonDismissed = ref(localStorage.getItem(STORAGE_DISMISSED) === "true");

let initialized = false;

function ensureInit() {
  if (initialized) return;
  initialized = true;
  const store = useAppStore();

  watch(
    () => store.license,
    (license) => {
      if (!license || Object.keys(license).length === 0) return;
      ready.value = true;
    },
    { immediate: true },
  );
}

function setSidebarOpen(open) {
  sidebarOpen.value = open;
  localStorage.setItem(STORAGE_OPEN, String(open));
}

function setButtonDismissed(dismissed) {
  buttonDismissed.value = dismissed;
  localStorage.setItem(STORAGE_DISMISSED, String(dismissed));
}

export function useQuickStart() {
  ensureInit();

  const store = useAppStore();
  const canSeeQuickStart = computed(
    () => (store.isAdmin || store.isPlanningIntervalAdmin) && store.license?.type === "trial",
  );
  const sidebarVisible = computed(() => ready.value && canSeeQuickStart.value && sidebarOpen.value);

  return {
    ready,
    canSeeQuickStart,
    sidebarOpen,
    sidebarVisible,
    buttonDismissed,
    setSidebarOpen,
    setButtonDismissed,
  };
}
